<script>
    import { onMount } from 'svelte';
    import NavLink from './NavLink.svelte';
    import SocialButton from './SocialButton.svelte';

    let root;
    onMount(() => {
        const burger = root.querySelector('#burger');
        const menu = root.querySelector('#menu');

        burger.addEventListener('click', () => {
        if (menu.classList.contains('hidden')) {
            menu.classList.remove('hidden');
        } else {
            menu.classList.add('hidden');
        }
    })
    });
</script>

<div class="md:flex md:justify-center md:col-span-1" bind:this={root}>

    <nav class="flex flex-col text-center">
        <div class="flex md:justify-center justify-between items-center mb-5">
            <div>
                <h1 class="text-xl md:text-4xl font-barlow p-4">
                    <a href="/" >Jesse Kroon</a>
                </h1>
                <h2 class="font-barlow md:text-lg">{`<Developer />`}</h2>
            </div>
            <div class="px-4 cursor-pointer md:hidden" id="burger">
                <svg class="w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
                </svg>
            </div>
        </div>
        

        <div id="menu" class="md:flex font-barlow text-lg md:mt-6 hidden md:flex-col flex-grow mb-2">
            <NavLink name='Home' on:message/>
            <NavLink name='Projects' on:message/>
        </div>

        <ul id="socials" class="md:flex justify-between hidden my-40 mx-4">
            <SocialButton src="./icons/Twitter.png" link="https://twitter.com/icedteatech" alt="twitter profile"/>
            <SocialButton src="./icons/Youtube.png" link="https://www.youtube.com/channel/UCH-UE02rLQbJmwkSzvDYmPA" alt="youtube channel"/>
            <SocialButton src="./icons/Facebook.png" link="https://www.facebook.com/IcedTeaTech2020" alt="facebook page"/>
            <SocialButton src="./icons/Instagram.png" link="https://www.instagram.com/icedteatech/" alt="instagram profile"/>
        </ul>
    </nav>

</div><!-- End Nav-->